const capitalize = (text: string) => {
  return text.toLowerCase().replace(/(?<= )[^\s]|^./g, (a) => a.toUpperCase())
}

export default capitalize
